<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row type="flex" justify="space-between">
          <!-- <el-select
            v-model="value"
            placeholder="请选择"
            class="application-wrapper"
            size="medium"
            @click="changeCompany"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
          <!-- <ScreeCompany @ScreeCompany="ScreeCompany" :allowField="allowField" /> -->
          <div class="table-right">
            <el-select
            v-model="value1"
            placeholder="请选择导出类型"
            @change="selectData"
            class="select-box"
            size="medium"
            >
            <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
            </el-option>
            </el-select>
            <el-button
            :loading="downloadLoading"
            style="margin: 0 0 20px 20px"
            type="primary"
            size="medium"
            icon="el-icon-document"
            @click="handleDownload"
            >
            导出
            </el-button>
          </div>
        </el-row>
		<!-- <el-row :span="24" style="display: flex"> -->
		<!-- <ScreeCompany @ScreeCompany="ScreeCompany" /> -->
		<!-- </el-row> -->
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item"
          >
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            highlight-current-row
            @switchPaging="switchPaging"
          >
            <el-table-column
              v-if="activeName == 'billing'"
              align="center"
              label="审核通过时间"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.apply_time  }}</div>
              </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="开票状态">
              <template slot-scope="scope">
                <div>{{ scope.row.alias_status }}</div>
              </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="驳回原因">
              <template slot-scope="scope">
                <div style="color: #f56c6c">{{ scope.row.review_remark }}</div>
              </template>
            </el-table-column>
            <el-table-column width="300" align="left" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="invoice(scope.row.id)"
                  class="operation-btn"
                  v-if="scope.row.alias_status == '开票中'"
                  >开票
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="reInvoice(scope.row.id)"
                  class="operation-btn"
                  v-if="scope.row.alias_status == '复核失败' && is_again_invoice"
                  >重新开票
                </el-button>
                <el-button
                  type="text"
                  @click="viewApplyDetails(scope.row.id)"
                  class="operation-btn"
                  v-if="
                    scope.row.alias_status == '复核中' ||
                    scope.row.alias_status == '发票寄出' ||
                    scope.row.alias_status == '复核通过'
                  "
                >
                  申请详情
                </el-button>
                <el-button
                  type="text"
                  @click="viewBillDetails(scope.row.id)"
                  class="operation-btn"
                  v-if="
                    scope.row.alias_status == '复核中' ||
                    scope.row.alias_status == '复核失败' ||
                    scope.row.alias_status == '发票寄出' ||
                    scope.row.alias_status == '复核通过'
                  "
                >
                  开票详情
                </el-button>
                <el-button
                  type="text"
                  @click="viewExpressInfo(scope.row.id)"
                  class="operation-btn"
                  v-if="scope.row.alias_status == '发票寄出'"
                  >快递详情
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="send(scope.row.id)"
                  class="operation-btn"
                  v-if="scope.row.alias_status == '复核通过' && is_send_out"
                  >寄出
                </el-button>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
      <!-- 上传开票信息 开票信息 -->
      <ModalDialog
        :dialogData="dialogData"
        @dialogConfirm="handleConfirm"
        @dialogClose="dialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item prop="invoiceNumber" v-if="this.showTitle == 'view'">
              <template slot="label">
                <div class="mail-title">数目：</div>
              </template>
              <span class="mail-content">{{ ruleForm.invoiceNumber }}</span>
            </el-form-item>
            <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">发票：</div>
              </template>
              <upload-file
                v-if="this.showTitle == 'upload'"
                class="invoice-wrapper"
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                @before_upload="beforeUpload"
                :title="'开票信息'"
                :multiple="'true'"
                :multiSelection="true"
                :dir="'invoice'"
                :selectfiles="'importService'"
                :postfiles="'submitImportService'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
            </el-form-item>
            <div class="invoice-img" v-if="this.showTitle == 'view'">
              <div v-for="(item, index) in ruleForm.invoiceImg" :key="index">
                <a
                  :href="item"
                  target="_blank"
                  v-if="item.slice(-4) == '.pdf' || item.slice(-4).toLowerCase() == '.zip' || item.slice(-4).toLowerCase() == '.rar'"
                  class="invoicePDF"
                  >{{ item }}</a
                >
                <img
                  v-else
                  :class="index != 0 ? 'new-mail-img' : 'mail-img'"
                  :src="item"
                />
              </div>
              <div
                v-if="ruleForm.invoiceNumber > 1"
                @click="expendMore"
                class="expend"
              >
                展开
              </div>
            </div>
          </el-form>
        </template>
		<template slot='footer'>
			<div style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-button size="medium"  :loading="sys.loading"  @click="downZIP(invoiceForm.invoice)" >一键下载zip</el-button>
				<el-button size="medium" type="primary"   @click="dialogClose" >关闭</el-button>
			</div>
		</template>
	</ModalDialog>
      <!-- 发票寄出、查看快递 -->
      <ModalDialog
        :dialogData="sendDialogData"
        @dialogConfirm="sendHandleConfirm"
        @dialogClose="sendDialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="sendRuleForm"
            ref="sendRuleForm"
            class="demo-ruleForm"
          >
            <el-form-item prop="expressName">
              <template slot="label">
                <div class="mail-title">快递名称：</div>
              </template>
              <!-- <el-input v-model="sendRuleForm.expressName" v-if="!this.isLook"></el-input> -->
              <span class="mail-content">{{ sendRuleForm.expressName }}</span>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <template slot="label">
                <div class="mail-title">快递单号：</div>
              </template>
              <el-input
                style="width: 86%"
                v-model="sendRuleForm.courierNumber"
                v-if="!this.isLook"
              ></el-input>
              <span class="mail-content" v-if="this.isLook">{{
                sendRuleForm.courierNumber
              }}</span>
            </el-form-item>
            <!-- <el-form-item prop="invoice">
              <template slot="label" v-if="this.isLook">
                <div class="mail-title">快递图片</div>
              </template>
              <upload-file
                v-if="!this.isLook"
                style="margin-left:80px"
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                @before_upload="beforeUpload"
                :title="'快递信息'"
                :multiple="'true'"
                :multiSelection="true"
                :dir="'invoice'"
                :selectfiles="'importService'"
                :postfiles="'submitImportService'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
              <div v-for="(item, index) in sendRuleForm.mailImg" :key="index">
                <img :class="index != 0 ? 'new-mail-img' : 'mail-img'" :src="item" />
              </div>
              <div v-if=" sendRuleForm.mailImg && sendRuleForm.mailImg.length > 1" @click="expendMore" class="expend">展开</div>
            </el-form-item> -->
          </el-form>
        </template>
      </ModalDialog>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from "@/components/ModalDialog";
import UploadFile from "@/components/UploadFile";
import ApeTable from "@/components/ApeTable";
// import ScreeCompany from "@/components/ScreeCompany.vue";
import DatePicker from "@/components/DatePicker.vue";
import {downloadFileUrl} from '@/utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    UploadFile,
    // ScreeCompany,
    DatePicker,
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "sendRuleForm.courierNumber": function (val) {
      if (val) {
        if (this.isLook) {
          console.log("11111");
          this.sendDialogData.loading = false;
        } else {
          console.log("222");
          this.sendDialogData.loading = false;
        }
      } else {
        if (this.isLook) {
          console.log("3333");
          this.sendDialogData.loading = false;
        } else {
          console.log("4444");
          this.sendDialogData.loading = true;
        }
        console.log("sendRuleForm.courierNumber");
      }
    },
  },
  data() {
    return {
    value1: "xlsx",
	bookType: "xlsx",
    downloadLoading: false,
	options1: [
	{
	value: "xlsx",
	label: "xlsx",
	},
	{
	value: "csv",
	label: "csv",
	},
	{
	value: "txt",
	label: "txt",
	},
	],
	isLaowuCompany:false,
	sys:{
		id:'',
		loading:false,
		info:{},
	},
      nowCompany:localStorage.getItem('nowCompany')?JSON.parse(localStorage.getItem('nowCompany')):{},
      allowField: ["companyId"],
      ruleForm: {
        // expressName: '',
        // courierNumber: '',
        invoiceImg: "",
        invoiceNumber: "",
      },
      sendRuleForm: {
        id: "",
        expressName: "",
        courierNumber: "",
        mailImg: "",
      },
      invoice_imgs: "",
      invoiceId: "",
      dialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: false,
        modal: false,
      },
      sendDialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: true,
        modal: false,
      },
      showTitle: "",
      showButton: ["cancel"],
      checkTitle: "",
      loadingStaus: false,
      tabsList: [
        {
          label: "全部",
          name: "all",
        },
        {
          label: "开票中",
          name: "billing",
        },
        {
          label: "复核中",
          name: "underReview",
        },
        {
          label: "复核通过",
          name: "passThereview",
        },
        {
          label: "复核驳回",
          name: "reviewRejected",
        },
        {
          label: "发票寄出",
          name: "invoiceSent",
        },
      ],
      activeName: "all",
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      options: [
        {
          value: "北京筑帷科技有限公司",
          label: "北京筑帷科技有限公司",
        },
        {
          value: "北京筑帷科技有限公司1",
          label: "北京筑帷科技有限公司1",
        },
        {
          value: "北京筑帷科技有限公司2",
          label: "北京筑帷科技有限公司2",
        },
        {
          value: "北京筑帷科技有限公司3",
          label: "北京筑帷科技有限公司3",
        },
      ],
      value: "公司名称",
      dataList: [],
      columns: [
        {
          title: "编号",
          value: "id",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票时间",
          value: "apply_time",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票金额",
          value: "invoice_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "开票公司",
          value: "company_name",
          header_align: "center",
          align: "center",
        },
		{
		title: "实发金额",
		value: "send_money",
		header_align: "center",
		align: "center",
		},
		{
		title: "企业费率",
		value: "rate",
		header_align: "center",
		align: "center",
		},
        {
          title: "服务公司",
          value: "channel_name",
          header_align: "center",
          align: "center",
        },
      ],
      searchCondition: {
        company: "",
        serviceCompany: "",
      },
      isLook: false,
      is_again_invoice:true, //是否能重新开票
      is_send_out:true, //是否 可以寄出
    };
  },
  methods: {
		// 是否是劳务公司
		async getIsLaoWu(){
		let settlementList = await this.$api.getUserSettlement({
			company_id:JSON.parse(localStorage.getItem('nowCompany')).id
		})
		console.log(settlementList)
		let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
		let newSettlementList = Object.assign(settlementList, [])

		newSettlementList.map(item=>{
			if(item.id == companyIds){
				if(item.is_labor_dispatch != 0){
					this.isLaowuCompany = true
				}
			}
		})
		},
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true;
      let list = await this.init("export");
      console.log(list,'导出数据');
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = [
          "编号",
          "申请开票时间",
          "申请开票金额",
          "开票类型",
          "开票公司",
		"实发金额",
		"企业费率",
          "服务公司",
          "开票类目",
          "邮箱",
          "备注",
          "开票状态",
          "驳回原因",
          "纳税人识别号",
          "地址电话",
          "开户银行及账号"
        ];
        let data = this.formatJson(list);
        let time = new Date().getTime() + Math.random() * 1000;
        let filename = `发票代开${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    selectData(e) {
    this.bookType = e;
    },
    formatJson(jsonData) {
      let invoiceTypeList = {
        0:'普通发票',
        1:'增值税专用发票'
      }
      return jsonData.map((v) => {
        let {
          id, //编号
          created_at, //申请开票时间
          invoice_money, //申请开票金额
          invoice_type, // 开票类型
          company_name, //开票公司
		send_money,//实发金额
		rate,//企业费率
		channel_name, //服务公司
          invoice_category_name,//开票类目
          receiver_email, //邮箱
          remark, //备注
          alias_status, //开票状态
          check_remark, //驳回原因
          company
        } = v;
		
		let remittance_taxpayer = company.taxpayer
		let remittance_address = `${company.address},${company.legal_phone}`
		let remittance_bank = `${company.bank},${company.account}`
		
        return [
          id, //编号
          created_at, //申请开票时间
          invoice_money, //申请开票金额
          invoiceTypeList[invoice_type], // 开票类型
          company_name, //开票公司
		send_money,//实发金额
		rate,//企业费率
          channel_name, //服务公司
          invoice_category_name.join(','),//开票类目
          receiver_email, //邮箱
          remark, //备注
          alias_status, //开票状态
          check_remark, //驳回原因
          remittance_taxpayer,
          remittance_address,
          remittance_bank
        ];
	});
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // ScreeCompany(v, name) {
    //   if (name == "company") {
    //     if (v) {
    //       this.searchCondition.company_id = v;
    //     } else {
    //       delete this.searchCondition.company_id;
    //     }
    //     this.init("search");
    //   }
    // },
    // ScreeCompany(v, name) {
    //   console.log(v, name);
    //   if (name == "company") {
    //     if (v) {
    //       this.searchCondition.company_id = v;
    //     } else {
    //       delete this.searchCondition.company_id;
    //     }
    //     this.init("search");
    //   } else if (name == "settlement") {
    //     if (v) {
    //       this.searchCondition.channel_account = v;
    //     } else {
    //       delete this.searchCondition.channel_account;
    //     }
    //     this.init("search");
    //   }
    // },
    //展开更多图片
    expendMore() {
      let node = document.getElementsByClassName("new-mail-img");
      for (let i = 0; i < node.length; i++) {
        node[i].style.display = "block";
      }
      let expend = document.getElementsByClassName("expend")[0];
      expend.style.display = "none";
    },
    //查看快递信息
    async viewExpressInfo(id) {
      this.isLook = true;
      this.sendDialogData.title = `快递信息查看${id}`;
      this.checkTitle = "关闭";
      this.sendDialogData.loading = false;
      this.sendDialogData.visible = true;
      console.log("viewExpressInfo", this.sendDialogData.loading);
      let args = { id: id };
      let result = await this.$api.invoiceManageExpressDetails(args);
      if (result) {
        this.sendRuleForm = {
          expressName: "顺丰",
          courierNumber: result.express_no,
          mailImg: result.express_img.split(","),
        };
      }
    },
    //寄出
    send(id) {
      this.sendRuleForm.id = id;
      this.showTitle = "send";
      this.checkTitle = "确定";
      this.sendDialogData.title = `发票寄出`;
      this.sendRuleForm.expressName = "顺丰";
      this.sendDialogData.visible = true;
      this.isLook = false;
    },
    // 选择公司
    changeCompany(e) {
      console.log(e, "公司");
      this.searchCondition.company = e;
    },
    // 选择服务公司
    changeServiceCompany(e) {
      console.log(e, "服务公司");
      this.searchCondition.serviceCompany = e;
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == "all") {
        // 全部
        delete this.searchCondition.status;
        delete this.searchCondition.invoice_status;
        this.init("all");
      } else if (tab.name == "billing") {
        // 开票中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 1;
        this.init("billing");
      } else if (tab.name == "underReview") {
        // 复核中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 2;
        this.init("underReview");
      } else if (tab.name == "passThereview") {
        // 复核通过
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 3;
        this.init("passThereview");
      } else if (tab.name == "reviewRejected") {
        // 复核驳回
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 5;
        this.init("reviewRejected");
      } else if (tab.name == "invoiceSent") {
        // 发票寄出
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 4;
        this.init("invoiceSent");
      }
    },
    //获取开票审核列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }

      // this.loadingStaus = false;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      if (type == "export") {
        pagingInfo.page_size = 5000;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages } = await this.$api.getInvoiceManageList(
        searchCondition
      );

      if (type == "export") {
        return list;
      }
      this.$nextTick(() => {
        this.dataList = list;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.company) {
        condition.company = this.searchCondition.company;
      }
      if (this.searchCondition.serviceCompany) {
        condition.serviceCompany = this.searchCondition.serviceCompany;
      }
      if (this.searchCondition.status === 0 || this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (
        this.searchCondition.invoice_status === 0 ||
        this.searchCondition.invoice_status
      ) {
        condition.invoice_status = this.searchCondition.invoice_status;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      if (
        this.searchCondition.company_id ||
        this.searchCondition.channel_account
      ) {
        condition.company_id = this.searchCondition.company_id;
        condition.channel_account = this.searchCondition.channel_account;
      }
      return condition;
    },
    //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text", load_text);
      this.dialogData.loading = true;
    },
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({ url, filename, load_text, title }) {
      console.log("->上传成功....", url, filename, load_text, title);
      this.invoice_imgs += `${url} `;
      this.dialogData.loading = false;
    },
    // 开票
    invoice(id) {
      this.$router.push({
        path: "/invoice_partner/detail",
        query: { id: id, title: "开票管理", sign: "开票"}
        // query: { id: id, title: "开票管理", sign: "开票",isLaowuCompany:JSON.stringify(this.isLaowuCompany) },
      });
      // this.invoiceId = id
      // this.dialogData.title = '上传开票信息'
      // this.checkTitle = '确定'
      // this.showTitle = 'upload'
      // this.dialogData.visible = true
      // this.dialogData.loading = true
    },
    reInvoice(id) {
      this.$router.push({
        path: "/invoice_partner/detail",
        query: { id: id, title: "开票管理", sign: "重新开票" },
      });
    },
    //保存上传开票信息
    async saveInvoiceInFo() {
      this.invoice_imgs = this.invoice_imgs.split(" ").slice(0, -1);
      let args = {
        invoice_imgs: this.invoice_imgs,
        id: this.invoiceId,
      };
      let result = await this.$api.uploadInvoiceInfo(args);
      if (result) {
        this.$message.success("保存成功");
        if (this.activeName == "all") {
          this.init();
        } else {
          this.searchCondition.status = 2;
          this.searchCondition.invoice_status = 2;
          this.init("underReview");
          this.activeName = "underReview";
        }
      } else {
        this.$message.error("保存失败");
      }
      console.log(result);
    },
    //查看开票管理详情
    async viewBillDetails(id) {
	this.sys.id=id
      this.dialogData.title = `发票查看${id}`;
      this.showTitle = "view";
      this.checkTitle = "关闭";
      this.dialogData.visible = true;
      this.dialogData.loading = false;
      let args = {
        id: id,
      };
      let result = await this.$api.getInvoiceManageDetail(args);
      if (result) {
		this.sys.info=result
        this.ruleForm = {
          invoiceImg: result.invoice_imgs,
          invoiceNumber: result.invoice_img_num,
        };
      }
    },
	async downZIP(arr){
		if(!arr?.length){
			return   this.$message.warning("暂无发票");
		}
		if(this.sys.info.zip_url){
		return	downloadFileUrl(this.sys.info.zip_url,'发票')
		}
		this.sys.loading=true
		let result = await this.$api.downZIP({id:this.sys.id});
		this.sys.loading=false
		if(!result){
			return   this.$message.warning("正在生成中 ,稍后再试");
		}
		downloadFileUrl(result,'发票')
		console.log(result)
	},
    //查看开票管理详情
    viewApplyDetails(id) {
      this.$router.push({
        path: "/invoice_partner/detail",
        query: { id: id, title: "开票管理"}
        // query: { id: id, title: "开票管理",isLaowuCompany:JSON.stringify(this.isLaowuCompany) },
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      if (this.showTitle == "upload") {
        this.saveInvoiceInFo();
      }
      this.dialogData.visible = false;
      this.ruleForm = {};
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      if (this.showTitle == "upload") {
        this.dialogData.loading = true;
        this.ruleForm = {};
      } else {
        this.dialogData.loading = false;
      }
      this.checkTitle = "";
    },
    // 处理寄出模态框，确定事件
    sendHandleConfirm() {
      if (this.checkTitle == "确定") {
        // if(this.invoice_imgs) {
        //   this.sendOutInvoice()
        // }else {
        //   this.$message.info("请先上传图片")
        // }
        this.sendOutInvoice();
      }
      if (this.checkTitle == "关闭") {
        this.sendDialogData.visible = false;
      }
    },
    //发票寄出
    async sendOutInvoice() {
      if (!Array.isArray(this.invoice_imgs)) {
        this.invoice_imgs = this.invoice_imgs.split(" ").slice(0, -1);
      }
      let args = {
        id: this.sendRuleForm.id,
        express_no: this.sendRuleForm.courierNumber,
        receiver_fullname: this.sendRuleForm.expressName,
        express_img: this.invoice_imgs,
      };
      let result = await this.$api.getInvoiceManageEdit(args);
      if (result) {
        this.$message.success("寄出成功");
        if (this.activeName == "all") {
          this.init();
        } else {
          this.searchCondition.status = 2;
          this.searchCondition.invoice_status = 4;
          this.init("invoiceSent");
          this.activeName = "invoiceSent";
        }
        this.sendRuleForm = {};
        this.sendDialogData.visible = false;
        this.sendDialogData.loading = true;
        this.checkTitle = "";
        this.isLook = false;
      } else {
        this.$message.error("寄出失败");
      }
    },
    // 处理模态框，确定事件
    sendDialogClose() {
      // 调用组件的数据验证方法
      this.sendDialogData.visible = false;
      this.sendRuleForm = {};
      this.isLook = false;
      this.sendDialogData.loading = true;
    },
  },
  mounted() {
    this.init();
    this.getIsLaoWu()
    let shuiyoudiList = ['sycard', 'syalipay', 'sywechat']
    let lignxinList = ['lingxin','lingxincard','lingxinalipay','lingxinwechat']
    if(lignxinList.includes(this.nowCompany.trade_bank_type) || shuiyoudiList.includes(this.nowCompany.trade_bank_type)){
        this.is_again_invoice = false
    }
    if(lignxinList.includes(this.nowCompany.trade_bank_type)){
        this.is_send_out = false
    }
  },
};
</script>

<style lang="scss" scoped>
.table-right{
  float: right;
}
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.operation-btn {
  margin: 0 20px;
}

.el-button + .el-button {
  margin-left: 0;
}

.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
}

.invoice-img {
  width: 100%;
}

.new-mail-img {
  width: 100%;
  display: none;
}

.mail-img {
  width: 100%;
}

.mail-title {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.mail-content {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.invoice-wrapper {
  margin-left: 55px;
}

.expend {
  text-align: center;
  margin-top: 20px;
  color: #333;
}

/deep/ .demo-ruleForm .el-form-item__label {
  padding: 0 !important;
}

/deep/ .vue-uploader {
  width: 98%;
}

.invoicePDF {
  text-decoration: none;
  text-align: center;
  display: block;
}
</style>






